import { createReducer, on } from '@ngrx/store';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '@shared/ngrx-factory/factory.reducer';
import {
  GetVesselNominationActions,
  ListVesselNominationsActions,
  SaveVesselNominationActions,
  SubmitVesselNominationActions,
  UpdateVesselNominationActions,
  VesselNominationState,
} from './vessel-nomination.actions';

const initialRequestState = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialVesselNominationState: VesselNominationState = {
  list: initialRequestState,
  details: initialRequestState,
  saveDraft: initialRequestState,
  updateDraft: initialRequestState,
  submitNomination: initialRequestState,
};

export const vesselNominationReducer = createReducer(
  initialVesselNominationState,

  // List Vessel Nominations
  on(ListVesselNominationsActions.request, (state) => handleRequest(state, 'list')),
  on(ListVesselNominationsActions.success, (state, { response }) =>
    handleSuccess(state, 'list', response),
  ),
  on(ListVesselNominationsActions.failure, (state, { error }) =>
    handleFailure(state, 'list', error),
  ),
  on(ListVesselNominationsActions.clearState, (state) => handleClear(state, 'list')),

  // Get Vessel Nomination Details
  on(GetVesselNominationActions.request, (state) => handleRequest(state, 'details')),
  on(GetVesselNominationActions.success, (state, { response }) =>
    handleSuccess(state, 'details', response),
  ),
  on(GetVesselNominationActions.failure, (state, { error }) =>
    handleFailure(state, 'details', error),
  ),
  on(GetVesselNominationActions.clearState, (state) => handleClear(state, 'details')),

  // Save Vessel Nomination Draft
  on(SaveVesselNominationActions.request, (state) => handleRequest(state, 'saveDraft')),
  on(SaveVesselNominationActions.success, (state, { response }) =>
    handleSuccess(state, 'saveDraft', response),
  ),
  on(SaveVesselNominationActions.failure, (state, { error }) =>
    handleFailure(state, 'saveDraft', error),
  ),
  on(SaveVesselNominationActions.clearState, (state) => handleClear(state, 'saveDraft')),

  // Update Vessel Nomination Draft
  on(UpdateVesselNominationActions.request, (state) => handleRequest(state, 'updateDraft')),
  on(UpdateVesselNominationActions.success, (state, { response }) =>
    handleSuccess(state, 'updateDraft', response),
  ),
  on(UpdateVesselNominationActions.failure, (state, { error }) =>
    handleFailure(state, 'updateDraft', error),
  ),
  on(UpdateVesselNominationActions.clearState, (state) => handleClear(state, 'updateDraft')),

  // Submit Vessel Nomination
  on(SubmitVesselNominationActions.request, (state) => handleRequest(state, 'submitNomination')),
  on(SubmitVesselNominationActions.success, (state, { response }) =>
    handleSuccess(state, 'submitNomination', response),
  ),
  on(SubmitVesselNominationActions.failure, (state, { error }) =>
    handleFailure(state, 'submitNomination', error),
  ),
  on(SubmitVesselNominationActions.clearState, (state) => handleClear(state, 'submitNomination')),
);
